"use client";

import dynamic from 'next/dynamic';
// MUI ThemeProvider moved to a client-only dynamic module to reduce initial JS

const SiteDrawer = dynamic(() => import('./layout/SiteDrawer'), { ssr: false });
const LazyFacebookPixel = dynamic(() => import('./analytics/LazyFacebookPixel'), { ssr: false });
const AmplitudeLazy = dynamic(() => import('./analytics/AmplitudeLazy'), { ssr: false });
const GoogleAnalyticsLazy = dynamic(() => import('./analytics/GoogleAnalyticsLazy'), { ssr: false });
const ClientThemeProvider = dynamic(() => import('./ClientThemeProvider'), { ssr: false });

type Props = {};

export default function ClientWidgets(_props: Props) {
  const gaId = process.env.NEXT_PUBLIC_GA_ID;
  return (
    <ClientThemeProvider>
      <SiteDrawer />
      <LazyFacebookPixel />
      <AmplitudeLazy />
      {gaId ? <GoogleAnalyticsLazy gaId={gaId} /> : null}
    </ClientThemeProvider>
  );
}
